module.exports = __webpack_public_path__ + "static/media/lc-03.dab8a443.jpg";